import { Button, Checkbox, Col, DatePicker, Form, Input, Row, Select, Spin } from 'antd';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { debounce } from '../../../../components/Common/Debounce';
import { getLearners } from '../../../../services/learnerService';

const { Option } = Select;
const PromoCodeSearch = ({
  onSearch,
  onReset,
  form,
  initialValues,
  courses,
  courseOffers,
}) => {
  const promoTypeMenu = [
    {
      label: 'Coupon',
      value: 'coupon',
    },
    { label: 'Gift card', value: 'giftCard' },
    { label: 'Referral', value: 'referral' },
  ].map((type, index) => (
    <Option value={type.value} key={index}>
      {type.label}
    </Option>
  ));

  const allOptions = [{ label: 'All', value: 'All' }];

  const [fetching, setFetching] = useState(false);
  const [referrerOptions, setReferrerOptions] = useState([]);
  const [assignedToOptions, setAssignedToOptions] = useState([]);
  const [giftedByOptions, setGiftedByOptions] = useState([]);

  const fetchLearnersHandler = debounce((value, type) => {
    setFetching(true);
    getLearners(0, 0, {
      name: value,
      sortBy: 'firstName',
      sortOrder: 'asc',
    })
      .then((response) => {
        const data = response.data.paginatedList.map((learner) => ({
          label: `${learner.firstName} ${learner.lastName} (${learner.email})`,
          value: type === 'referrer' ? learner._id : learner.email,
        }));
        if (type === 'referrer') {
          setReferrerOptions(data);
        } else if (type === 'assignedTo') {
          setAssignedToOptions(data);
        } else if (type === 'giftedBy') {
          setGiftedByOptions(data);
        }
        setFetching(false);
      })
      .catch((err) => {
        alert(err);
      });
  }, 250);
  return (
    <Form form={form} onFinish={onSearch} initialValues={initialValues}>
      <Row gutter={16}>
        <Col span={2}>
          <Form.Item name="param" rules={[{ required: false }]}>
            <Select placeholder="Search by..." defaultValue="code">
              <Option value="code">Code</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="val" rules={[{ required: false }]}>
            <Input placeholder="Enter the search term..." />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="Course" name="coursesAllowed">
            {courses ? (
              <Select
                options={[...allOptions, ...courses]}
                placeholder={'Select Courses'}
                mode="multiple"
                notFoundContent={null}
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              />
            ) : null}
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="Course Offers" name="courseOffersAllowed">
            {courseOffers ? (
              <Select
                options={[...allOptions, ...courseOffers]}
                placeholder={'Select Course Offers'}
                mode="multiple"
                notFoundContent={null}
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              />
            ) : null}
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={4}>
          <Form.Item label="Type" name="type">
            <Select placeholder={'Select type'}>{promoTypeMenu}</Select>
          </Form.Item>
        </Col>
        <Col span={4}>
        <Form.Item name="isActive" valuePropName="checked">
            <Checkbox>
              Is Active?
            </Checkbox>
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item label="Value Type" name="discountType">
            <Select>
              <Select.Option value="percent_off">Percent Off</Select.Option>
              <Select.Option value="amount_off">Amount Off</Select.Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name="isCorporate" valuePropName="checked">
            <Checkbox>
              Is Corporate?
            </Checkbox>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="Referrer" name="referrerId">
            <Select
              placeholder="Search learners"
              options={referrerOptions}
              notFoundContent={fetching ? <Spin size="small" /> : null}
              filterOption={false}
              showSearch={true}
              onSearch={(value) => fetchLearnersHandler(value, 'referrer')}
              style={{ width: '100%' }}
            />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item label="Assigned to email" name="assignedToEmail">
            <Select
              placeholder="Search learners"
              options={assignedToOptions}
              notFoundContent={fetching ? <Spin size="small" /> : null}
              filterOption={false}
              showSearch={true}
              onSearch={(value) => fetchLearnersHandler(value, 'assignedTo')}
              style={{ width: '100%' }}
              name="assignedToEmail"
            />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item label="Gifted by email" name="giftedByEmail">
            <Select
              placeholder="Search learners"
              options={giftedByOptions}
              notFoundContent={fetching ? <Spin size="small" /> : null}
              filterOption={false}
              showSearch={true}
              onSearch={(value) => fetchLearnersHandler(value, 'giftedBy')}
              style={{ width: '100%' }}
              name="giftedByEmail"
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col>
          <Form.Item
            label="Start Date"
            name="startDate"
            rules={[{ required: false, message: 'Please input start date!' }]}
          >
            <DatePicker
              showTime={true}
              showNow={false}
              style={{ width: '100%' }}
            />
          </Form.Item>
        </Col>

        <Col>
          <Form.Item
            label="End Date"
            name="endDate"
            rules={[{ required: false, message: 'Please input end date!' }]}
          >
            <DatePicker
              showTime={true}
              showNow={false}
              style={{ width: '100%' }}
            />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Search
            </Button>
            <Button htmlType="button" onClick={onReset}>
              Reset
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

PromoCodeSearch.propTypes = {
  onSearch: PropTypes.func,
  onReset: PropTypes.func,
  initialValues: PropTypes.object,
};

export default PromoCodeSearch;
